import { Typography } from '@blofin/blofin-ui';
import { useDevice } from 'hooks/activityCenter/useDevice';
import { useTranslations } from 'next-intl';
import clsx from 'clsx';

const Cond = ['cons-1', 'cons-2', 'cons-3', 'cons-4'];

export default function Conditions() {
  const t = useTranslations('activity');
  const { isMobile } = useDevice();

  return (
    <div className="mb-[16px] mt-[32px] md:my-[80px]">
      <Typography variant={isMobile ? 'subtitle2' : 'h6'} weight="bold" className="text-light-label">
        {t('conditions')}
      </Typography>
      <ul className="mt-[16px] text-light-label-40 md:mt-[24px]">
        {Cond.map((item, index) => (
          <li key={index} className={clsx('text-lg leading-[26px]', isMobile && 'flex')}>
            {isMobile && <i className="mx-[6px] text-[30px]">·</i>}
            {t(item)}
          </li>
        ))}
      </ul>
    </div>
  );
}
